module.exports = __webpack_public_path__ + "img/Raven_demo.bfdc944c.gif";